export default "__VITE_ASSET__C1ML8CqZ__"